const FILE_UPLOAD_TYPE = "wix-draft-plugin-file-upload";

export { FILE_UPLOAD_TYPE };
//# sourceMappingURL=types.js.map
